import { render, staticRenderFns } from "./Fairs.vue?vue&type=template&id=67c2c052"
import script from "./Fairs.vue?vue&type=script&lang=js"
export * from "./Fairs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports